export const SIGNIN_ROUTE = '/sign-in';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const CHANGE_PASSWORD_ROUTE = '/change-password';
export const USER_INFO_ROUTE = '/my-user';
export const INVITE_USER_ROUTE = '/invite-user';
export const ACCEPT_INVITATION_ROUTE = '/accept-terms';